export const STORY_ID = 'STORY_ID';
export const REMOVE_STORY_ID = 'REMOVE_STORY_ID';
export const REMOVE_ALL_STORY_ID = 'REMOVE_ALL_STORY_ID';
export const PLAYLIST_DETAILS = 'PLAYLIST_DETAILS';
export const PLAYLIST_DETAILS_BY_ID = 'PLAYLIST_DETAILS_BY_ID';
export const STORY_DETAILS_BY_PLAYLIST_ID = 'STORY_DETAILS_BY_PLAYLIST_ID';
export const DELETED_PLAYLIST = 'DELETED_PLAYLIST';
